import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DocumentTemplateComponent } from "./document-template.component";
import { SharedModule } from "../shared/shared.module";

@NgModule({
  declarations: [DocumentTemplateComponent],
  imports: [CommonModule, SharedModule],
  exports: [DocumentTemplateComponent],
})
export class DocumentTemplateModule {}
